
<template>
  <v-container fluid>
    <v-row v-if="loggedRoleId == 2 && localPatientId == 0">
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="moment(startDate).format('MM-DD-YYYY')"
              label="START DATE"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="moment(endDate).format('MM-DD-YYYY')"
              label="END DATE"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="endDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-btn @click="downloadCsv()" color="primary">EXPORT</v-btn>
      </v-col>
    </v-row>

    <!-- <v-btn v-if="loggedRoleId == 2" color="primary" @click="downloadCsv()"
      >EXPORT</v-btn
    > -->

    <v-card-title>
      <h2>Assessment Report</h2>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="SEARCH"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assessments"
      :search="search"
      item-key="name"
      class="elevation-1"
      dense
    >
      <template v-slot:[`item.completionDate`]="{ item }">
        <span>{{
          moment(item.completionDate).format("MM-DD-YYYY HH:mm")
        }}</span>
      </template>
      <template v-slot:[`item.receivedDate`]="{ item }">
        <span>{{ moment(item.receivedDate).format("MM-DD-YYYY HH:mm") }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
//import axios from "axios";
/* eslint-disable no-debugger */
export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    startDateMenu: false,
    endDateMenu: false,
    assessments: [],
    headers: [
      { text: "RESPONSE ID", value: "responseId" },
      { text: "ASSESSMENT ID", value: "assessmentTypeId" },
      { text: "ASSESSMENT NAME", value: "assessmentTypeName" },
      { text: "QUESTION", value: "questionName" },
      { text: "PATIENT ID (int)", value: "patientId" },
      { text: "PATIENT ID (ext)", value: "externalPatientId" },
      { text: "SITE ID", value: "siteId" },
      { text: "RATING", value: "rate" },
      { text: "DATE SUBMITTED", value: "completionDate" },
      { text: "DATE SYNCED", value: "receivedDate" },
    ],
    search: "",
  }),
  methods: {
    downloadCsv() {
      //OID40001
      var patientId =
        this.$route.query.patientId == null ? 0 : this.$route.query.patientId;

      this.$http
        .request({
          url:
            this.$store.getters.getBaseUrl +
            "assessmentReport/?isReport=true&patientId=" +
            patientId +
            "&startDate=" +
            this.startDate +
            "&endDate=" +
            this.endDate,
          method: "GET",
          responseType: "blob",
        })
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "assessmentReport.csv"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  },
  created: () => {
    //console.log("run created");
  },
  mounted() {
    console.log("run mounted");
    console.log(this.$route.query.patientId);

    this.startDate = this.moment().subtract(20, "days").format("YYYY-MM-DD");

    var patientId =
      this.$route.query.patientId == null ? 0 : this.$route.query.patientId;

    const baseURI =
      this.$store.getters.getBaseUrl +
      "assessmentReport/?patientId=" +
      patientId;
    this.$http.get(baseURI).then((result) => {   
      this.assessments = result.data
    });
  },
  computed: {
    loggedRoleId() {
      return this.$store.getters.getRoleId;
    },
    localPatientId() {
      return this.$route.query.patientId == null
        ? 0
        : this.$route.query.patientId;
    },
  },
};
</script>